import React, { useState, useEffect } from "react";
import { ToastProvider } from "react-toast-notifications";

import { Auth } from "aws-amplify";
import { library as FontAwesomeLibrary } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Routes from "./Routes";
import { AuthContext } from "./contexts/authContext";

import { onError } from "./libs/errorLib";

function App() {
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [username, setUsername] = useState(null);
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    FontAwesomeLibrary.add(fas);
    try {
      let session = await Auth.currentSession();
      userHasAuthenticated(true);
      setUsername(session.idToken.payload.email);
    } catch (e) {
      if (e !== "No current user") {
        onError(e);
      }
    }
    setIsAuthenticating(false);
  }
  return (
    !isAuthenticating && (
      <AuthContext.Provider
        value={{ isAuthenticated, userHasAuthenticated, username }}
      >
        <ToastProvider
          autoDismiss={true}
          autoDismissTimeout={3000}
          placement="bottom-right"
        >
          <Routes />
        </ToastProvider>
      </AuthContext.Provider>
    )
  );
}

export default App;
